import { createApp } from 'vue'
import App from './App.vue'
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

createApp(App)
    .use(VueAxios, axios)
    .use(VueSweetalert2, {
        confirmButtonColor: '#41b882',
        cancelButtonColor: '#ff7674',
    })
    .mount('#app')
